import { render } from "./MBPButton.vue?vue&type=template&id=fdae7a96&scoped=true"
import script from "./MBPButton.vue?vue&type=script&lang=js"
export * from "./MBPButton.vue?vue&type=script&lang=js"

import "./MBPButton.vue?vue&type=style&index=0&id=fdae7a96&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdae7a96"]])

export default __exports__